import './Navbar.css';
import React, {useState, useEffect} from 'react';
import { ReactComponent as IconUser } from '../Img/icon-user.svg';
import { ReactComponent as IconAPI } from '../Img/icon-API.svg';
import { ReactComponent as Restitutions } from '../Img/icon-restitutions.svg';
import { ReactComponent as Organismes } from '../Img/icon-organismes.svg';
import { useHistory } from 'react-router-dom';


const NavbarAdmin = () =>
{
    let history = useHistory();
    // const [aff, setAff] = useState(false)

    const purple = '#6571FE'
    const greyChapter = '#DBDBDB'
    
        
    useEffect(() => {
    }, [])
    

	return (
        <div className='shadow-md' style={{flex: 1, backgroundColor: 'white', marginTop: 0.5, display: 'flex', minHeight: 65}}>

            {/* Bouton Gestion de la table Application */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/gestion/application'
            }}
            >
                <IconAPI width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Application</p>
            </button>

            {/* Bouton Gestion des Organismes */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/gestion/organismes'
            }}
            >
                <Organismes width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Organismes</p>
            </button>

            {/* Bouton Gestion des utilisateurs */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/gestion/utilisateurs'
            }}
            >
                <IconUser width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Utilisateurs</p>
            </button>

            {/* Bouton Gestion des Restitutions */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/gestion/restitutions'
            }}
            >
                <Restitutions width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Restitutions</p>
            </button>

            <div style={{flex: 1}}></div>

        </div>
	);
}

export default NavbarAdmin;
